// Feature-flag helpers for gradually rolling out the production-session
// redesign and the new A4 box label print flow.
//
// The phased production flow and box printing are restricted to these users.
// All other users continue to see the legacy UI / sticker-only printing.
//
// The independent visual refinement is configured separately below.

const NEW_PRODUCTION_UX_USERNAMES = ['fmazza', 'garauz', 'Eramirez'];
const BOX_LABEL_PRINT_USERNAMES = ['fmazza'];

// One build-time allowlist controls the appearance across all layouts and
// production. Exact, case-sensitive usernames only; empty disables the pilot.
// Legacy settings below remain fallbacks only when this setting is absent.
const REFINED_UI_USERNAMES = process.env.REACT_APP_REFINED_UI_USERNAMES;
const parseUsernames = (value = '') => value.split(',').map((username) => username.trim()).filter(Boolean);

// Older production-only configuration, for example:
// REACT_APP_REFINED_PRODUCTION_UI_USERNAMES=fmazza,Eramirez
// An empty or missing value keeps the refinement off. This list cannot grant
// access to the phased production flow beyond its existing rollout above.
const REFINED_PRODUCTION_UI_USERNAMES = parseUsernames(
  REFINED_UI_USERNAMES === undefined
    ? process.env.REACT_APP_REFINED_PRODUCTION_UI_USERNAMES
    : REFINED_UI_USERNAMES
);

// App-wide appearance can be piloted separately from the phased production
// workflow. Until explicitly configured, reuse the existing visual allowlist.
// An explicitly empty app allowlist disables this broader appearance pilot.
const REFINED_APP_UI_USERNAMES = parseUsernames(
  REFINED_UI_USERNAMES === undefined
    ? (process.env.REACT_APP_REFINED_APP_UI_USERNAMES === undefined
      ? process.env.REACT_APP_REFINED_PRODUCTION_UI_USERNAMES
      : process.env.REACT_APP_REFINED_APP_UI_USERNAMES)
    : REFINED_UI_USERNAMES
);

const getUsername = (currentUser) => {
  // Tolerate both the redux shape ({ user: { username } }) and a plain
  // user object, so callers can pass whichever they have on hand.
  if (!currentUser) return null;
  if (currentUser.user && currentUser.user.username) return currentUser.user.username;
  if (currentUser.username) return currentUser.username;
  return null;
};

export const canUseNewProductionUX = (currentUser) => {
  const username = getUsername(currentUser);
  return !!username && NEW_PRODUCTION_UX_USERNAMES.includes(username);
};

export const canUseRefinedProductionUI = (currentUser) => {
  const username = getUsername(currentUser);
  return canUseNewProductionUX(currentUser) && REFINED_PRODUCTION_UI_USERNAMES.includes(username);
};

export const canUseRefinedAppUI = (currentUser) => {
  const username = getUsername(currentUser);
  return !!username && REFINED_APP_UI_USERNAMES.includes(username);
};

export const canUseBoxLabelPrint = (currentUser) => {
  const username = getUsername(currentUser);
  return !!username && BOX_LABEL_PRINT_USERNAMES.includes(username);
};
